export const USER = 'USER'
export const FARM = 'FARM'
export const BATCH = 'BATCH'
export const CORRAL = 'CORRAL'
